export default "__VITE_ASSET__973522b9__"